

export const frontMatter = {};
export const contentTitle = 'Working with Images';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-basics-working-with-images-md-662.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import ImageDemo from './image.demo.tsx';
export const toc = [{
  "value": "What is an Image?",
  "id": "what-is-an-image",
  "level": 3
}, {
  "value": "Types of images supported by ImagesJS",
  "id": "types-of-images-supported-by-imagesjs",
  "level": 3
}, {
  "value": "Image coordinates",
  "id": "image-coordinates",
  "level": 3
}, {
  "value": "Properties",
  "id": "properties",
  "level": 3
}, {
  "value": "Features",
  "id": "features",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h3: "h3",
    header: "header",
    img: "img",
    li: "li",
    p: "p",
    pre: "pre",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "working-with-images",
        children: "Working with Images"
      })
    }), "\n", _jsx(_components.h3, {
      id: "what-is-an-image",
      children: "What is an Image?"
    }), "\n", _jsx(_components.p, {
      children: "In the context of digital technology and computing, images are represented as a grid of pixels, with each pixel containing information about color and intensity."
    }), "\n", _jsx(ImageDemo, {}), "\n", _jsx(_components.h3, {
      id: "types-of-images-supported-by-imagesjs",
      children: "Types of images supported by ImagesJS"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Currently ImageJS supports images with these characteristics:"
      }), "\n"]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {}), _jsx(_components.th, {
            children: "TIFF"
          }), _jsx(_components.th, {
            children: "JPEG"
          }), _jsx(_components.th, {
            children: "PNG"
          }), _jsx(_components.th, {
            children: "BMP"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Bits per channel"
            })
          }), _jsx(_components.td, {
            children: "8 or 16 bits"
          }), _jsx(_components.td, {
            children: "8 bits"
          }), _jsx(_components.td, {
            children: "8 or 16 bits"
          }), _jsx(_components.td, {
            children: "1 bit"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Alpha channel"
            })
          }), _jsx(_components.td, {
            children: "yes"
          }), _jsx(_components.td, {
            children: "no"
          }), _jsx(_components.td, {
            children: "yes"
          }), _jsx(_components.td, {
            children: "no"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Lossy compression"
            })
          }), _jsx(_components.td, {
            children: "can be either"
          }), _jsx(_components.td, {
            children: "yes"
          }), _jsx(_components.td, {
            children: "no"
          }), _jsx(_components.td, {
            children: "no"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Color Model"
            })
          }), _jsx(_components.td, {
            children: "RGB or grayscale"
          }), _jsx(_components.td, {
            children: "RGB"
          }), _jsx(_components.td, {
            children: "RGB or grayscale"
          }), _jsx(_components.td, {
            children: "N/A"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Can be loaded in this format"
            })
          }), _jsx(_components.td, {
            children: "✅"
          }), _jsx(_components.td, {
            children: "✅"
          }), _jsx(_components.td, {
            children: "✅"
          }), _jsx(_components.td, {
            children: "❌"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Can be saved in this format"
            })
          }), _jsx(_components.td, {
            children: "❌"
          }), _jsx(_components.td, {
            children: "✅"
          }), _jsx(_components.td, {
            children: "✅"
          }), _jsx(_components.td, {
            children: "✅"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "image-coordinates",
      children: "Image coordinates"
    }), "\n", _jsx(_components.p, {
      children: "The origin point has coordinates (0,0) and is located in the top-left corner of an image."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "Image coordinates",
        src: require("!/opt/buildhome/repo/node_modules/url-loader/dist/cjs.js?limit=10000&name=assets/images/[name]-[contenthash].[ext]&fallback=/opt/buildhome/repo/node_modules/file-loader/dist/cjs.js!./workingWithImages/coordinatesImage.jpg").default + "",
        width: "300",
        height: "297"
      })
    }), "\n", _jsx(_components.p, {
      children: "So, if we want to get a certain pixel on the image we will be counting the distance from image's top-left corner."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "//We will receive 20th row and 10th column\n//from the top-left corner.\nconst pixel = image.getPixel(10, 20);\n"
      })
    }), "\n", _jsx(_components.h3, {
      id: "properties",
      children: "Properties"
    }), "\n", _jsx(_components.p, {
      children: "In ImageJS main properties of an image are:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "width"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "height"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "data: typed array with information about image's pixels."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/Glossary#color-model",
            title: "internal link on color model",
            children: "Color model"
          }), ": the abstract model of how pixel colors are formed."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/Glossary#bit-depth",
            title: "internal link on bit depth",
            children: "Bit depth"
          }), ": number of bits allocated to each channel."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/Glossary#channel",
            title: "internal link on channels",
            children: "Number of channels"
          }), ": number of color channels that each pixel has. Grey image has one, RGB-type of image has three."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/Glossary#component",
            title: "internal link on components",
            children: "Number of components"
          }), ": number of color channels that each pixel has but without alpha channel."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/Glossary#alpha-channel",
            title: "internal link on alpha-channel",
            children: "Alpha channel"
          }), ": channel that represents the transparency or opacity levels of pixels."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/Glossary#metadata",
            title: "internal link on metadata",
            children: "Metadata"
          }), ": data about data. A basic example would be date and time when an image was taken."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "features",
      children: "Features"
    }), "\n", _jsx(_components.p, {
      children: "Currently, there are several ways of processing an image:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/Features/Filters/",
            title: "internal link on filters",
            children: "Filtering"
          }), ": filters usually apply some sort of ", _jsx(_components.a, {
            href: "/docs/Glossary#kernel",
            title: "internal link on kernel",
            children: "kernel"
          }), " to change an image."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/Features/Comparison/",
            title: "internal link on comparison",
            children: "Comparison"
          }), ": these features compare two images for further feature matching between the two."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/Features/Geometry/",
            title: "internal link on geometry",
            children: "Geometry"
          }), ": this part of ImageJS allows rotating and resizing an image."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/Features/Morphology/",
            title: "internal link on morphology",
            children: "Morphology"
          }), ": enables shape analysis and shape identification."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/Features/Regions%20of%20interest/",
            title: "internal link on roi analysis",
            children: "ROI analysis"
          }), ": these features allow targeting and extracting relevant information from specific regions of interest."]
        }), "\n"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

